import { z } from 'zod/v4'

/**
 * Typed URL state for the per-label Fraud Score filters on the Identification Events page (DASH-3093).
 *
 * Not rendered and not sent to the API yet: Warden and mgmt-api events search don't support Fraud Score
 * filters, and the request contract is for the Core team to decide. Filtering a paginated page on the
 * client would be misleading, so this only reserves the URL shape. Once the contract exists (DASH-3148), map
 * {@link FraudScoreFilters} to its query params in one place next to the other events search params.
 *
 * Invalid values are dropped rather than failing route validation, so a stale or hand-edited URL still
 * opens the page.
 */
export const fraudScoreFiltersSearchSchema = z.object({
  /** Minimum `ml_score` per label slug, in [0, 1], e.g. `{ payment_fraud: 0.8 }` */
  fraudScoreMinMlScore: z.record(z.string().min(1), z.number().min(0).max(1)).optional().catch(undefined),
  /** Required `prediction` per label slug, e.g. `{ payment_fraud: true }` */
  fraudScorePrediction: z.record(z.string().min(1), z.boolean()).optional().catch(undefined),
})

export type FraudScoreFilters = z.infer<typeof fraudScoreFiltersSearchSchema>
